module.exports = {"340881001":"龙腾街道","340881002":"文昌街道","340881003":"龙眠街道","340881100":"孔城镇","340881101":"吕亭镇","340881102":"范岗镇","340881103":"新渡镇","340881104":"双港镇","340881105":"大关镇","340881106":"青草镇","340881107":"金神镇","340881108":"嬉子湖镇","340881109":"唐湾镇","340881110":"黄甲镇","340881111":"鲟鱼镇","340881400":"桐城经济开发区","340881401":"桐城双新经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340881.json
// module id = 1013
// module chunks = 0